{
  "status": {
    "pending_verification": "本人確認待ち",
    "active": "有効",
    "suspended": "一時停止",
    "closed": "終了"
  },
  "columns": {
    "reference": "番号",
    "name": "お名前",
    "kyc": "本人確認",
    "items": "預かり中",
    "awaiting": "支払い待ち",
    "payout": "支払い方法",
    "no_account": "口座なし",
    "status": "状態"
  },
  "filters": {
    "q": "検索",
    "q_placeholder": "お名前、カナ、CON- 番号、メール"
  },
  "views": {
    "not_verified": "本人確認がまだ"
  },
  "list": {
    "intro": "お店にカードを預けて販売を任せる方。カードを受け取る前に本人確認（古物営業法）が必要です。",
    "create": "新しい委託者"
  },
  "locales": {
    "en": "English",
    "ja": "日本語",
    "th": "ไทย",
    "zh_Hant": "繁體中文",
    "zh_Hans": "简体中文"
  },
  "payout": {
    "bank_transfer": "銀行振込",
    "cash": "店頭で現金",
    "store_credit": "ストアクレジット",
    "stripe_connect": "オンライン支払い"
  },
  "fee": {
    "shop_absorbs": "カード手数料はお店が負担",
    "consignor_pro_rata": "カード手数料は委託者が按分で負担",
    "split_50_50": "半分ずつ"
  },
  "fee_help": {
    "shop_absorbs": "買った人の支払い方法にかかわらず、委託者には価格から手数料を引いた額。",
    "consignor_pro_rata": "カードで買われたとき、そのカードの手数料を支払いから差し引きます。",
    "split_50_50": "カード手数料をお店と支払いから半分ずつ。"
  },
  "schedule": {
    "monthly": "月 1 回",
    "on_request": "依頼があったとき"
  },
  "form": {
    "profile": "詳細",
    "displayName": "表示名",
    "displayName_hint": "スタッフとポータルでの呼び方。",
    "legalName": "氏名（本名）",
    "legalName_hint": "本人確認書類どおり（古物台帳用）。",
    "nameKana": "フリガナ",
    "email": "メール",
    "phone": "電話",
    "locale": "言語",
    "address": "住所",
    "postalCode": "郵便番号",
    "region": "都道府県",
    "city": "市区町村",
    "address1": "番地",
    "address2": "建物・部屋",
    "payoutMethod": "支払い方法",
    "commission": "お店の手数料",
    "commission_hint": "空欄 = お店の通常ルール。",
    "payoutSchedule": "支払いの間隔",
    "minPayout": "最低支払額",
    "minPayout_hint": "これより少ない額は次回に。",
    "feePolicy": "カード手数料（カードで買われたとき）",
    "invoiceRegistered": "インボイス登録あり（登録番号あり）",
    "taxId": "登録番号",
    "taxId_hint": "T と 13 桁、例：T1234567890123",
    "baikaisha_note": "登録済みの委託者：お店が代わりにインボイスを交付できます（媒介者交付特例）。⚠️ 使い方は税理士に確認してください。",
    "notes": "メモ（スタッフだけ）",
    "save": "詳細を保存",
    "saved": "詳細を保存しました",
    "stale": "この委託者はいま誰かが変更しました。もう一度開いてください。"
  },
  "problems": {
    "display_name": "名前を書いてください。",
    "email": "メールが正しくないようです。",
    "commission": "0〜100 の % で。",
    "tax_id": "T と 13 桁。",
    "min_payout": "円（整数）で。",
    "fix": "先に赤い欄を直してください。"
  },
  "bank": {
    "title": "支払い用の口座",
    "none": "口座はまだありません。",
    "add": "口座を登録",
    "change": "新しい口座を入れる",
    "description": "口座をすべて入れてください。暗号化して保存し、以後スタッフには下のけたしか見えません。",
    "later": "銀行振込での支払いには口座が必要です。まだなければ、いまは現金かストアクレジットを選んでください。",
    "bankName": "銀行名",
    "branchCode": "支店番号",
    "branch_hint": "3 桁（ゆうちょは通帳を見て）。",
    "accountNumber": "口座番号",
    "holderKana": "口座名義（カナ）",
    "accountType": "種類",
    "save": "口座を保存",
    "saved": "口座を保存しました",
    "incomplete": "口座はすべての欄を数字で入れるか、全部空欄にしてください。",
    "required": "銀行振込には口座が必要です — 入力するか、現金／ストアクレジットを選んでください。"
  },
  "kpi": {
    "active": "預かり中",
    "sold": "売れた",
    "awaiting": "支払い待ち",
    "paid": "これまでの支払い"
  },
  "stages": {
    "received": "受付",
    "under_review": "確認中",
    "ready_to_list": "出品準備完了",
    "listed": "販売中",
    "reserved": "注文あり",
    "paused": "一時停止",
    "sold": "売れた",
    "return_in_progress": "返却中",
    "returned": "返却済み",
    "closed": "完了"
  },
  "link": {
    "title": "ポータルのログイン",
    "open": "お客様アカウントを開く",
    "email": "ポータル用のメール",
    "hint": "委託者はこのメールで自分のカードと支払いを見ます。",
    "send_invite": "招待メールを送る",
    "submit": "アカウントをつなぐ",
    "created": "アカウントを作ってつなぎました",
    "linked": "アカウントをつなぎました",
    "invited": "{{email}} に招待を送りました。"
  },
  "status_change": {
    "needs_kyc": "先に本人確認をしてください。",
    "to": {
      "active": "有効にする",
      "suspended": "一時停止",
      "closed": "終了する",
      "pending_verification": "確認待ちに戻す"
    },
    "title": {
      "active": "この委託者を有効にしますか？",
      "suspended": "この委託者を一時停止しますか？",
      "closed": "この委託者を終了しますか？",
      "pending_verification": "確認待ちに戻しますか？"
    },
    "consequence": {
      "active": "カードを受け取り、販売できます。",
      "suspended": "新しいカードは受け取りません。販売中のカードはそのまま。",
      "closed": "新しいカードは受け取りません。預かり中のカードは先に販売か返却を。",
      "pending_verification": "本人確認が終わるまでカードを受け取りません。"
    },
    "done": {
      "active": "委託者を有効にしました",
      "suspended": "委託者を一時停止しました",
      "closed": "委託者を終了しました",
      "pending_verification": "確認待ちに戻しました"
    }
  },
  "agreement": {
    "title": "委託契約書",
    "accepted": "署名済み（第 {{version}} 版）",
    "missing": "未署名 — カードを受け取れません。",
    "record": "委託者が第 {{version}} 版に署名しました",
    "record_title": "署名した契約書を記録しますか？",
    "record_consequence": "委託者がお店で紙の契約書に署名したときだけ。",
    "record_confirm": "記録する",
    "recorded": "契約書を記録しました",
    "open_pdf": "署名済みの契約書を開く"
  },
  "view_as": {
    "button": "委託者として見る",
    "opened": "委託者のポータルを新しいタブで開きました",
    "hint": "閲覧のみ・15 分。記録されます。"
  },
  "detail": {
    "back": "委託者一覧",
    "load_failed": "委託者を開けませんでした",
    "status_reason": "理由：",
    "privacy": "口座と本人確認の番号は暗号化して保存。見るたびに記録されます。",
    "take_in": "委託品を受け付ける",
    "their_cards": "この方のカード",
    "their_sales": "この方の販売",
    "pay_now": "支払う"
  },
  "new": {
    "title": "新しい委託者",
    "intro": "少しの情報を入れて、すぐ本人確認へ。",
    "save": "保存して本人確認へ",
    "created": "{{reference}} を作りました",
    "created_hint": "次は本人確認です。"
  },
  "masked": {
    "show": "表示",
    "hide": "隠す（{{seconds}} 秒）",
    "recorded": "この表示は記録されます。30 秒で自動的に隠れます。"
  },
  "address": {
    "postalCode": "郵便番号",
    "region": "都道府県",
    "city": "市区町村",
    "address1": "番地",
    "address2": "建物・部屋",
    "country": "国",
    "postal_hint": "7 桁で残りが入ります。",
    "postal_found": "住所を入れました — 番地を足してください。",
    "postal_unknown": "この郵便番号は見つかりません — 住所を入れてください。"
  },
  "kyc": {
    "title": "本人確認",
    "state": {
      "verified": "✅ 確認済み",
      "expired": "⚠️ 期限切れ — 再確認",
      "pending": "確認待ち",
      "rejected": "❌ 不可",
      "missing": "❌ 未確認"
    },
    "start": "本人確認をする",
    "again": "もう一度確認",
    "none_body": "まだです。本人確認のあとでないとカードを受け取れません。",
    "details_hidden": "本人確認の詳細は、見る権限のあるスタッフだけ。",
    "form_title": "本人確認",
    "form_description": "書類を見て、法律で必要なことだけ入力し、写真を撮ります。",
    "save_verified": "書類を確認した — 保存",
    "save_pending": "保存（あとで確認）",
    "saved_verified": "本人確認が済みました",
    "saved_pending": "本人確認を保存 — 確認待ち",
    "valid_until": "{{day}} まで有効。",
    "valid_until_label": "有効期限",
    "checked": "確認日",
    "channel": "どこで",
    "channels": {
      "face_to_face": "店頭（対面）",
      "remote": "非対面（郵送・オンライン）"
    },
    "method": "どの書類？",
    "methods": {
      "drivers_license": "運転免許証",
      "my_number_card": "マイナンバーカード",
      "passport": "パスポート",
      "residence_card": "在留カード",
      "health_insurance_card": "健康保険証",
      "other_official_id": "その他の公的書類",
      "remote_ekyc_photo_id": "オンライン：写真付き書類＋顔",
      "remote_ic_chip": "オンライン：書類の IC チップ",
      "remote_my_number_signature": "オンライン：マイナンバー署名",
      "remote_seal_certificate": "印鑑証明書（郵送）",
      "remote_honnin_gentei_mail": "本人限定受取郵便",
      "remote_juminhyo_registered_mail": "住民票＋書留",
      "remote_juminhyo_same_name_transfer": "住民票＋同名口座への振込",
      "remote_id_copy_registered_mail_transfer": "書類の写し＋書留＋振込",
      "remote_two_ids_delivery_record": "書類 2 点＋配達記録",
      "remote_returning_customer_credential": "再来店（確認済みの方）",
      "remote_other_rule15_3": "その他（施行規則 15 条 3 項）"
    },
    "document_number_hint": "暗号化して保存。以後は下 4 けただけ表示。",
    "fields": {
      "full_name": "氏名",
      "name_kana": "フリガナ",
      "address": "住所",
      "occupation": "職業",
      "date_of_birth": "生年月日",
      "picture": "書類の写真",
      "document_number": "書類の番号",
      "document_expiry": "書類の有効期限"
    },
    "occupations": {
      "employee": "会社員",
      "self_employed": "自営業",
      "student": "学生",
      "homemaker": "主婦・主夫",
      "none": "無職"
    },
    "age": "年齢：{{age}} 歳",
    "age_at_check": "確認時の年齢",
    "dob_hint": "ここから年齢を出します。",
    "minor_title": "18 歳未満（{{age}} 歳）",
    "minor_body": "保護者の同意書（青少年条例）を添付してください — ないと保存できません。",
    "minor_blocked_body": "お店は 18 歳未満の方からカードを受け取りません。",
    "minor_short": "18 歳未満",
    "guardian_consent": "保護者の同意書（写真）",
    "picture_front": "書類 — 表",
    "picture_back": "書類 — 裏（必要なとき）",
    "picture_alt": "本人確認書類の写真 {{n}}",
    "show_picture": "写真 {{n}} を表示",
    "hide_picture": "隠す",
    "no_pictures": "写真はありません。",
    "privacy": "写真は暗号化して保存し、法律の期間（3 年）だけ保管します。",
    "blocker": {
      "minor_blocked": "18 歳未満：お店は受け付けません。",
      "blocked": "この確認は受け付けられません（お店のルール）。",
      "minor_consent": "18 歳未満：先に保護者の同意書を添付してください。",
      "missing": "まだ必要：{{fields}}。",
      "uploading": "写真のアップロードが終わるまでお待ちください。"
    },
    "verify": "確認済みにする",
    "verified": "本人確認を確認済みにしました",
    "reject": "不可にする",
    "rejected": "本人確認を不可にしました",
    "reject_title": "この確認を不可にしますか？",
    "reject_consequence": "委託者はもう一度書類を見せる必要があります。理由を書いてください。",
    "reject_reason": "不可の理由"
  }
}
